import React from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import clsx from 'clsx';

import {
  Button,
  ListItem,
  makeStyles
} from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0
  },
  button: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.fontSize * 1.1,
    fontWeight: theme.typography.fontWeightMedium,
    justifyContent: 'flex-start',
    letterSpacing: 0,
    padding: '10px 8px',
    textTransform: 'none',
    width: '100%'
  },
  icon: {
    marginRight: theme.spacing(1),
    width: '30px'
  },
  title: {
    marginRight: 'auto'
  },
  active: {
    color: theme.palette.primary.main,
    // '& $title': {
    //   fontWeight: theme.typography.fontWeightMedium
    // },
    // '& $icon': {
    //   color: theme.palette.primary.main
    // }
  }
}));

export const NavItem = ({
  className,
  href,
  icon,
  title,
  ...rest
}: any) => {
  const classes = useStyles();

  return (
    <ListItem
      className={clsx(classes.item, className)}
      disableGutters
      {...rest}
    >
      <Button
        activeClassName={classes.active}
        className={classes.button}
        component={RouterLink}
        to={href}
      >
        <span className={classes.icon}>
          {icon}
        </span>
        <span className={classes.title}>
          {title}
        </span>
      </Button>
    </ListItem>
  );
};
